<template>
  <div>
    <b-modal @close="onClose()" ref="modalAlertConfirmation" id="modalAlertConfirmation" no-close-on-backdrop centered
      modal-class="dialog-800" hide-footer title="ALERTA DE POSIBLES INCONVENIENTES">
      <section class="container-confirmation-modal">
        <feather-icon icon="AlertTriangleIcon" class="warning-icon"></feather-icon>
        <section v-show="rules.replace" class="msg-add-process">
          <p>Actualmente la organización <b>{{ ownerName }} - {{ ownerId }}</b>, tiene activa la siguiente regla <b>{{ currentRule}} - {{ currentRuleId }}</b></p>
          <p>Al activar esta regla <b>{{ newRuleName }} - {{ newRuleId }}</b>, se inhabilitará la regla antes mencionada.
          Este cambio podría afectar a todas las empresas que se encuentren heredando esta regla desde la organización.

          <b>¿Esta seguro que desea activar esta regla para toda la organización ?</b>
        </p>
        </section>
        <section v-show="!rules.replace" class="msg-add-process">
          <p> Este cambio podría afectar a todas las empresas que se encuentren heredando esta regla desde la organización.
          </p>
          <p>¿Esta seguro que desea inhabilitar esta regla en la organización <b>{{ ownerName }} - {{ ownerId }}</b> ?</p>
        </section>
        <section class="container-validate-buttons">
          <b-button variant="outline-danger" class="col-sm-4" @click="cancel">NO</b-button>
          <b-button variant="outline-success" class="col-sm-4" @click="confirm">SI</b-button>
        </section>
      </section>
    </b-modal>
  </div>
</template>
<script>

export default {
  props: {
    rules :{
      type: Object,
      required: true
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm-change')
      this.onClose()
    },
    cancel() {
      this.$emit('cancel-change')
      this.onClose()
    },
    onClose() {
      this.$bvModal.hide('modalAlertConfirmation')
    }
  },
  computed: {
    ownerName () {
      return this.rules.current?.owner?.name || ''
    },
    ownerId () {
      return this.rules.current?.owner?.id || ''
    },
    currentRule () {
      return this.rules.current?.name || ''
    },
    currentRuleId () {
      return this.rules.current?.id || ''
    },
    newRuleName () {
      return this.rules.newRuleName || ''
    },
    newRuleId () {
      return this.rules.newRuleId || ''
    }

  }
}
</script>
<style>
.warning-icon {
  color: #F18805;
  height: 10em;
  width: 10em;
  margin: auto;
  margin-bottom: 2em;
  stroke-width: 0.8;
}
.container-confirmation-modal {
  display: flex;
  flex-direction: column;
  padding: 1em 0.4em 5em;
  text-align: center;
}
.container-validate-buttons {
  display: flex;
  justify-content: space-evenly;
  padding: 0.3em;
}
</style>